import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'
import { FormattedMessage } from 'react-intl'

const MasterOrganizationSelectorModal = ({
    open,
    onClose,
    organizations,
    currentMasterOrgId,
    onSelect,
}) => {
    const [selected, setSelected] = useState('')

    useEffect(() => {
        if (open && currentMasterOrgId) {
            setSelected(currentMasterOrgId)
        }
    }, [open, currentMasterOrgId])

    const handleUpdate = () => {
        if (selected && selected !== currentMasterOrgId) {
            onSelect(selected)
        }
        onClose()
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <FormattedMessage
                    id="dashboard.student.overview.changeMasterOrganization"
                    defaultMessage="Change master organization"
                />
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <FormattedMessage
                        id="dashboard.student.overview.changeMasterOrganization.description"
                        defaultMessage="Select which organization should be the master organization for this user."
                    />
                </DialogContentText>
                <FormControl component="fieldset" style={{ width: '100%' }}>
                    <RadioGroup value={selected} onChange={(e) => setSelected(e.target.value)}>
                        {organizations.map((org) => (
                            <FormControlLabel
                                key={org.id}
                                value={org.id}
                                control={<Radio />}
                                label={org.name}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleUpdate} color="primary">
                    <FormattedMessage id="globalwords.update" defaultMessage="Update" />
                </Button>
                <Button onClick={onClose} color="primary">
                    <FormattedMessage id="globalwords.cancel" defaultMessage="Cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default MasterOrganizationSelectorModal
